// Importações dos componentes
import Activation from "@/Activation.vue";
import Begin from "@/pages/Begin.vue";
import Register from "@/pages/Register.vue";
import Domain from "@/pages/Domain.vue";
import Plan from "@/pages/Plan.vue";
import Finished from "@/pages/Finished.vue";
import Wellcome from "@/pages/Wellcome.vue";
import Onboarding from "@/pages/Onboarding.vue";

// Definição das rotas de ativação
let activationPages = {
  path: "/",
  component: Activation,
  name: "Activation",
  label: "Ativação",
  children: [
    {
      path: "inicio",
      name: "Begin",
      label: "Informe seu e-mail para começar",
      component: Begin
    },
    {
      path: "cadastro",
      name: "Register",
      label: "Informe seus dados para prosseguir",
      component: Register
    },
    {
      path: "dominio",
      name: "Domain",
      label: "Qual o endereço de sua loja?",
      component: Domain
    },
    {
      path: "plano",
      name: "Plan",
      label: "Comece imediatamente",
      component: Plan
    },
    {
      path: "concluido",
      name: "Finished",
      label: "Próximos passos",
      component: Finished
    },
    {
      path: "wellcome",
      name: "Wellcome",
      label: "Bem vindo à iSET!",
      component: Wellcome
    },
    {
      path: "onboarding",
      name: "Onboarding",
      label: "Guia: Prepare sua loja para vender",
      component: Onboarding
    }
  ]
};

// Configuração das rotas principais
const routes = [
  {
    path: "/",
    redirect: "/inicio",
    name: "Home",
    label: "Informe seu e-mail para começar"
  },
  activationPages,
  // Adicionar uma rota catch-all para lidar com rotas não encontradas
  {
    path: "*",
    redirect: "/inicio"
  }
];

export default routes;
